import {
  SleepEntity,
} from './sleepEntity';
import { MeasureDateTime } from './valueObjects/measureDateTime';
import { MeasurerId } from './valueObjects/measurerId';
import { MeasurerType } from './valueObjects/measurerType';
import { ParentId } from './valueObjects/parentId';

import type {
  SleepPropsPub,
  SleepPropsPvt,
} from './sleepEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { SleepJsonPub, SleepJsonPvt } from '@/types/domain/sleep/entities/sleepEntity';

import { FactoryPub } from '@/domain/factoryPub';

export class SleepFactory extends FactoryPub<
  SleepEntity,
  SleepPropsPvt,
  SleepJsonPvt,
  SleepPropsPub,
  SleepJsonPub
> {
  comparePub = (
    a: EntityDataPubType<SleepJsonPvt, SleepJsonPub>,
    b: EntityDataPubType<SleepJsonPvt, SleepJsonPub>,
  ) => {
    const da = new Date(a.data.measureDateTime);
    const db = new Date(b.data.measureDateTime);
    return da < db ? 1 : -1;
  };

  create(
    props: SleepPropsPvt,
    propsPub: EntityPubNotNullType<SleepPropsPub>,
  ): SleepEntity {
    return new SleepEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<SleepJsonPvt, SleepJsonPub>,
  ): SleepEntity {
    return this.create({
      isSleepTime: props.data.isSleepTime,
      measurerId: MeasurerId.create(props.data.measurerId),
      measurerType: MeasurerType.create(props.data.measurerType),
      measureDateTime: MeasureDateTime.create(new Date(props.data.measureDateTime)),
      parentId: ParentId.create(props.data.parentId),
      childId: ParentId.create(props.data.childId),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},
    });
  }
}
